import { Image, type ImageProps } from "@mantine/core"
import { useDidUpdate } from "@mantine/hooks"
import { useState } from "react"

export function ImageWithPlaceholder({ alt, placeholder, ...props }: ImageProps & { alt?: string; placeholder: any }) {
  const [error, setError] = useState(!props.src)

  useDidUpdate(() => {
    setError(!props.src)
  }, [props.src])

  return error ? (
    placeholder
  ) : (
    <Image
      style={{
        overflow: "hidden",
      }}
      {...props}
      alt={alt || ""}
      onError={() => setError(true)}
    />
  )
}
